import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import Dashboard from '../../../../../views/Threat/Dashboard/Dashboard';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/dashboard/')({
  component: Dashboard,
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.ShowThreatDashboard];
    context.validatePermissions({ isAllowed, preload });
  },
});
